'use client'

import { HeroUIProvider } from '@heroui/react'
import { useRouter } from 'next/navigation'

const UIProvider = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter()
  return <HeroUIProvider navigate={router.push}>{children}</HeroUIProvider>
}

export default UIProvider
